<content-loader [viewBox]="'0 0 1000 1820'" [speed]="2" class="mt-2">
  @for (item of [].constructor(8); track item; let i = $index) {
    <svg:rect x="10" [attr.y]="10 + (i * 260)" rx="30" ry="30" width="1000" height="230" />
  }
</content-loader>